import { logger } from '@neptune/shared/core-logger-util';

import { CompareRedirectUtils } from './compare-redirect-utils';

export async function processCompareParamAndGetCompareKey(
  workspaceName: string,
  projectIdentifier: string,
  compareKeys: string,
): Promise<string | undefined> {
  const parsed = CompareRedirectUtils.parseCompareJSON(compareKeys);

  if (!parsed || (parsed.customRunIds.length < 1 && parsed.experimentNames.length < 1)) {
    // eslint-disable-next-line no-console
    console.error('Invalid compare JSON format or empty keys', { compareKeys, parsed });
    logger.logMessage('Invalid compare JSON format or empty keys', { compareKeys, parsed });
    return undefined;
  }

  const runIds = await CompareRedirectUtils.translateCustomRunIdsToSysIds(
    projectIdentifier,
    parsed.customRunIds,
  );
  const experimentNames = parsed.experimentNames;

  return await CompareRedirectUtils.persistCompareKeysInScissors(
    workspaceName,
    projectIdentifier,
    runIds,
    experimentNames,
  );
}
